import Cobro from './Cobro';
export default Cobro;